import { v4 as uuid } from 'uuid';

import type { IVideoCreatorStore } from '../stores/IVideoCreatorStore';

type ElementProperties = Record<
  string,
  string | number | boolean | Record<string, any> | null | undefined
>;

export const getImageWithBlackFrameElements = (
  imageElementOverrides: { source: string } & ElementProperties,
  shapeOverrides?: ElementProperties,
): [ElementProperties, ElementProperties] => [
  {
    type: 'image',
    fit: 'contain',
    x: '50%',
    y: '50%',
    height: '100%',
    locked: true,
    color_overlay: '',
    ...imageElementOverrides,
    track: 2,
    time: 0,
    id: uuid(),
    z_index: 2, // Ensure proper z-index
  },
  {
    type: 'shape',
    width: '100%',
    height: '100%',
    x: '50%',
    y: '50%',
    fill_color: '#000',
    locked: true,
    path: 'M 0 0 L 100 0 L 100 100 L 0 100 L 0 0 Z',
    ...shapeOverrides,
    track: 1,
    time: 0,
    id: uuid(),
    z_index: 1, // Ensure proper z-index
  },
];

export const removeTinyVideoFragmentsFromSource = (source: any) => {
  const filteredElements = (source.elements as any[]).reduce(
    (newElements, element, idx, inputArr) => {
      if (element.type === 'video' && parseFloat(element.duration) < 1) {
        // also recalculate the time of the elements after
        // the removed video element
        inputArr.slice(idx + 1).forEach(el => {
          el.time -= element.duration;
        });
        return newElements;
      }
      newElements.push(element);
      return newElements;
    },
    [],
  );
  source.elements = filteredElements;
  return source;
};

export const findOriginalVideoElementAtCurrentTime = (
  videoCreator: IVideoCreatorStore,
) => {
  const time = videoCreator.time;
  for (const element of videoCreator.rootStore?.videoSourceStore?.source
    ?.elements || []) {
    if (!videoCreator.isOriginalVideoElement(element)) {
      continue;
    }
    // Each element's own span: the track needn't start at 0 or be gap-free.
    const start = parseFloat(element.time);
    if (time >= start && time < start + parseFloat(element.duration)) {
      return element;
    }
  }

  return null;
};
